import React from "react";
import { Outlet } from "react-router-dom";
import BreadcrumNav from "./BreadcrumbNav";

const AdminDBOutputPage = () => {
  return (
    <div>
      {/* Navigation Tabs should always be visible */}
      <BreadcrumNav />

      {/* Render the selected tab content */}
      <Outlet />
    </div>
  );
};

export default AdminDBOutputPage;
